require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./a-regular-beethoven.json") })
        }
      }, "path---a-regular-beethoven");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---a-regular-beethoven!./.cache/json/a-regular-beethoven.json
// module id = 493
// module chunks = 231608221292675